import { render, staticRenderFns } from "./ScoringCoverageCard.vue?vue&type=template&id=ab292220"
import script from "./ScoringCoverageCard.vue?vue&type=script&lang=js"
export * from "./ScoringCoverageCard.vue?vue&type=script&lang=js"
import style0 from "./ScoringCoverageCard.vue?vue&type=style&index=0&id=ab292220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports